import { render } from "./ReportIcon.vue?vue&type=template&id=91bf5958&scoped=true"
const script = {}

import "./ReportIcon.vue?vue&type=style&index=0&id=91bf5958&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91bf5958"]])

export default __exports__